import React, { useState, useEffect } from "react";
// import Webflow from

import myImage from "../../../../../Image/meepl_icon_second.svg";
// import "./OurProduct.css";
const texts = ["Style", "Code", "Design"];
const OurProduct = () => {
  const [, setIndex] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prevIndex) => (prevIndex + 1) % texts.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);
  // {texts[index]}
  return (
    <>
      <div className="section grey-section">
        <div className="container">
          <div className="hero-section">
            <div className="hero-section-text-holder">
              <div className="title-wrapper">
                <div className="animate-on-load-01">
                  <h1 className="title">Hire
                    <span className="text-box">
                      <span>Right</span>
                      <span>Fast</span>
                      <span>Now</span>
                    </span>
                    <span className="hidden-text">Style</span>
                  </h1>
                </div>
                <div className="animate-on-load-02">
                  <div className="title-with-lottie">
                    <h1 className="title">
                      with Meepl

                      {/* <div className="text-box">
                        <div>Check</div>
                        <div>Brand</div>
                        <div>Style</div>
                      </div> */}

                    </h1>

                    <div className="title-with-lottie-holder">
                      <div
                        data-is-ix2-target="1"
                        className="hero-lottie"
                        data-w-id="29858d05-365f-6c67-1ab8-4f1a1ca083c2"
                        data-animation-type="lottie"
                        data-src="https://assets.website-files.com/634e968b219cc43522715fb8/63564e5ea7b90c9796d30450_Orange.json"
                        data-loop="0"
                        data-direction="1"
                        data-autoplay="0"
                        data-renderer="svg"
                        data-default-duration="1.5166666666666666"
                        data-duration="0"
                        data-ix2-initial-state="0"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 412 49"
                          width="412"
                          height="49"
                          preserveAspectRatio="xMidYMid meet"
                        >
                          <defs>
                            <clipPath id="__lottie_element_66">
                              <rect width="412" height="49" x="0" y="0"></rect>
                            </clipPath>
                          </defs>
                          <g clipPath="url(#__lottie_element_66)">
                            <g transform="matrix(1,0,0,1,206,24.5)" opacity="1">
                              <g
                                opacity="1"
                                transform="matrix(1,0,0,1,0,0)"
                              ></g>
                            </g>
                            <g
                              transform="matrix(1,0,0,1,206.15199279785156,24.27199935913086)"
                              opacity="1"
                            >
                              <g opacity="1" transform="matrix(1,0,0,1,0,0)">
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  fillOpacity="0"
                                  stroke="rgb(254,203,3)"
                                  strokeOpacity="1"
                                  strokeWidth="2.818"
                                  d=" M-187.86900329589844,-6.781000137329102 C-165.48699951171875,-6.546000003814697 -143.62399291992188,-9.772000312805176 -121.30999755859375,-10.128999710083008 C-66.95800018310547,-10.99899959564209 -12.668000221252441,-11.008999824523926 41.68299865722656,-11.161999702453613 C89.95600128173828,-11.29800033569336 139.85899353027344,-11.967000007629395 187.86900329589844,-7.258999824523926 C168.08299255371094,-9.055000305175781 148.00599670410156,-6.830999851226807 128.13499450683594,-7.406000137329102 C79.55899810791016,-8.810999870300293 30.219999313354492,-8.803000450134277 -18.2450008392334,-5.446000099182129 C-37.14699935913086,-4.13700008392334 -55.904998779296875,-1.6990000009536743 -74.71099853515625,0.16699999570846558 C-78.83000183105469,0.5759999752044678 -89.47899627685547,0.07400000095367432 -92.88600158691406,2.0799999237060547 C-94.82099914550781,3.2179999351501465 -88.03800201416016,2.6600000858306885 -85.59200286865234,2.7230000495910645 C-79.95099639892578,2.868000030517578 -80.19499969482422,2.763000011444092 -74.73699951171875,2.6389999389648438 C-65.31300354003906,2.4240000247955322 -55.92300033569336,1.8669999837875366 -46.50400161743164,1.5989999771118164 C-15.199999809265137,0.7099999785423279 16.222000122070312,1.7029999494552612 47.53300094604492,1.496000051498413 C57.249000549316406,1.430999994277954 67.0459976196289,1.8420000076293945 76.76100158691406,2.072999954223633 C79.73999786376953,2.1440000534057617 82.71700286865234,2.2330000400543213 85.69499969482422,2.2939999103546143 C87.50700378417969,2.3320000171661377 92.86499786376953,2.805999994277954 91.13200378417969,2.4010000228881836 C56.15399932861328,-5.77400016784668 -7.872000217437744,0.023000000044703484 -43.6619987487793,1.9040000438690186 C-57.604000091552734,2.63700008392334 -71.66699981689453,3.434000015258789 -85.48799896240234,5.065999984741211 C-90.74500274658203,5.686999797821045 -96.00499725341797,6.120999813079834 -101.26599884033203,6.709000110626221 C-103.97200012207031,7.011000156402588 -109.54199981689453,7.7179999351501465 -109.36699676513672,7.896999835968018 C-108.0270004272461,9.274999618530273 -100.88400268554688,9.531999588012695 -99.24700164794922,9.60099983215332 C-86.69499969482422,10.130000114440918 -73.83999633789062,8.895000457763672 -61.275001525878906,8.710000038146973 C-17.57900047302246,8.065999984741211 30.631000518798828,4.26200008392334 73.81800079345703,11.272000312805176"
                                ></path>
                              </g>
                            </g>
                          </g>
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="hero-description">
                <div className="animate-on-load-03">
                  <p>
                    Revolutionizing Recruitment: Meepl ATS Simplifies
                    Collaboration Among Candidates, Companies, and Recruiters.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="hero-section-animation-holder">
            <div className="hero-section-animation-container">
              <div className="hero-section-app-logo-holder">
                <div className="hero-section-app-logo">
                  <div className="hero-section-users">
                    <div className="hero-profile-picutre-container _01">
                      <img
                        src="https://assets.website-files.com/634e968b219cc43522715fb8/63528c4cb4a5566fb541a797_Profile%20Picture%2003.webp"
                        loading="lazy"
                        alt=""
                        className="hero-profile-picutre"
                      />
                    </div>
                    <div className="hero-profile-picutre-container _02">
                      <img
                        src="https://assets.website-files.com/634e968b219cc43522715fb8/63528c4c0866471d45806ae3_Profile%20Picture%2002.webp"
                        loading="lazy"
                        alt=""
                        className="hero-profile-picutre"
                      />
                    </div>
                    <div className="hero-profile-picutre-container _03">
                      <img
                        src="https://assets.website-files.com/634e968b219cc43522715fb8/63528c4a71118188a715eae4_Profile%20Picture%2005.webp"
                        loading="lazy"
                        alt=""
                        className="hero-profile-picutre"
                      />
                    </div>
                    <div className="hero-profile-picutre-container _04">
                      <img
                        src="https://assets.website-files.com/634e968b219cc43522715fb8/63528c49738b37a81c90699e_Profile%20Picture%2004.webp"
                        loading="lazy"
                        alt=""
                        className="hero-profile-picutre"
                      />
                    </div>
                    <div className="hero-profile-picutre-container _05">
                      <img
                        src="https://assets.website-files.com/634e968b219cc43522715fb8/63528c49aff778f97b2538d2_Profile%20Picture%2001.webp"
                        loading="lazy"
                        alt=""
                        className="hero-profile-picutre"
                      />
                    </div>
                    <div className="hero-profile-picutre-container _06">
                      <img
                        src="https://assets.website-files.com/634e968b219cc43522715fb8/63528c490d7c3274f0cb9293_Profile%20Picture%2006.webp"
                        loading="lazy"
                        alt=""
                        className="hero-profile-picutre"
                      />
                    </div>
                  </div>
                  <div className="app-logo-holder">
                    <img
                      src={myImage}
                      loading="lazy"
                      alt=""
                      className="app-icon"
                    />
                    <div className="hero-text-logo">Meepl.</div>
                    <div className="hero-bg-holder">
                      <div className="hero-section-circle"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </>
  );
};

export default OurProduct;
